<template>
	<div class="cbs-number-control">
		<legend class="flex justify-between items-center">
			<div>{{ localValue.title }}<span class="text-danger" v-if="!localValue.is_optional">&nbsp;*</span>:</div>
			<cbs-hint
				v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.ICON"
				:data="localValue.description && localValue.description.value"
			/>
		</legend>

		<div class="my-1" v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.TOP">
			{{ localValue.description && localValue.description.value }}
		</div>
		<vx-input-group prependClasses="border border-solid border-grey border-r-0">
			<template slot="prepend" v-if="localUnitAttributeValue">
				<div class="prepend-text text-black">
					<span>{{ localUnitAttributeValue }}</span>
				</div>
			</template>

			<cbs-masked-input
				v-if="
					localFormatAttributeValue === $constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.NUMBER.TYPE_MONEY ||
					localFormatAttributeValue === $constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.NUMBER.TYPE_NUMERIC
				"
				dataType="int"
				data-vv-delay="100"
				v-model.number="localValue.value"
				class="vs-inputx vs-input--input normal"
				v-validate="!localValue.is_optional ? 'required' : ''"
				:userSetting="userSettings"
				:data-vv-as="localValue.title"
				:name="`${localValue.title}-${localValue.id}`"
				:placeholder="`${$t('Actions.Input')} ${localValue.title.toLowerCase()}`"
			/>
			<cbs-input
				v-else-if="localFormatAttributeValue === $constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.NUMBER.TYPE_NONE"
				dataType="int"
				data-vv-delay="100"
				v-model="localValue.value"
				v-validate="{
					decimal: true,
					required: !localValue.is_optional
				}"
				:data-vv-as="localValue.title"
				:name="`${localValue.title}-${localValue.id}`"
				:placeholder="`${$t('Actions.Input')} ${localValue.title.toLowerCase()}`"
			/>
		</vx-input-group>
		<span class="text-danger text-sm">{{ errors.first(`${localValue.title}-${localValue.id}`) }}</span>
		<div class="my-1" v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.BOTTOM">
			{{ localValue.description && localValue.description.value }}
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import CbsHint from "@/components/cbs-hint/CbsHint.vue";

export default {
	name: "NumberControl",
	inject: ["parentValidator"],
	components: {
		vSelect,
		CbsHint
	},
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop =>
				prop.hasOwnProperty("id") &&
				prop.hasOwnProperty("value") &&
				prop.hasOwnProperty("title") &&
				prop.hasOwnProperty("control") &&
				prop.hasOwnProperty("children") &&
				prop.hasOwnProperty("attributes") &&
				prop.hasOwnProperty("is_optional") &&
				prop.hasOwnProperty("description")
		}
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		localAttributesValue() {
			const attributesValue = typeof this.localValue.attributes === "string" ? JSON.parse(this.localValue.attributes) : this.localValue.attributes;
			return attributesValue;
		},
		localFormatAttributeValue() {
			return this.localAttributesValue.format || this.$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.NUMBER.TYPE_NUMERIC;
		},
		localUnitAttributeValue() {
			return this.localAttributesValue.unit || "";
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>

<style></style>
